import { useState } from "react";
import { Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import GetStartedDropdown from "../../auth/GetStartedDropdown";
import MeetOurProfessionals from "../meet-our-professionals";
import BlogList from "../../Blogging/components/blog-list/BlogList";
import ExtraLargeButton from "components/extra-large-button";
// styles
import styles from "./styles.module.scss";
// contexts
import { useUser } from "contexts/UserContext";
// assets
import { ReactComponent as TextLogo } from "assets/svg/orchid-logo.svg";
import { ReactComponent as LandingGraphic } from "assets/svg/landing-graphic.svg";

const GeneralHomePhone = () => {
  const { user } = useUser();
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className={styles["general-home-phone"]}>
      {/* add logo for phone view */}
      <div className={styles["general-home-phone__logo"]}>
        <TextLogo className={"h-100"} />
      </div>
      <div className={styles["general-home-phone__top"]}>
        <LandingGraphic
          className={"mb-3 mt-0 w-100" + styles["general-home-phone__top-img"]}
        />
        <div className="deep-blue bd-17 mb-2 justify-content-center">
          {user && user.signup_form_finished
            ? `Welcome to Orchid!`
            : `Finish setting up`}
        </div>
        <p className="deep-blue rg-13-footnote mb-3">
          {user && user.signup_form_finished
            ? `Thanks for signing up and joining our community. Get started by booking your first session!`
            : `Verify your email to join our community and to start booking sessions.
            `}
        </p>
        <Link to="/professional-search">
          <ExtraLargeButton
            variant="primary"
            className="rg-13-footnote"
            style={{ maxWidth: "15.188rem" }}
          >
            Book a session
          </ExtraLargeButton>
        </Link>
      </div>

      {showDropdown ? (
        <GetStartedDropdown setShowDropdown={setShowDropdown} />
      ) : null}

      <MeetOurProfessionals />
      <Row className="justify-content-between px-4">
        <h5 className="fs-18 mb-0">Blogs by our professionals</h5>
        <Link to="/">See all</Link>
      </Row>
      <BlogList />
      <Container className={styles["general-home-phone__footer"]}>
        <p className="mb-0">
          If you have an emergency and need immediate help, call 911 or go to
          the nearest emergency room.
        </p>
        <p>
          Call +1-800-273-8255 or use{" "}
          <Link to="/" className="orange fw-500">
            these resources
          </Link>
        </p>
      </Container>
    </div>
  );
};

export default GeneralHomePhone;
